import api from "./api";

export const MOTIVO_OPCOES = [
  { value: "NOVA_OPORTUNIDADE", label: "Nova oportunidade" },
  { value: "REMUNERACAO", label: "Remuneração/benefícios" },
  { value: "LIDERANCA", label: "Liderança" },
  { value: "AMBIENTE", label: "Ambiente de trabalho" },
  { value: "CRESCIMENTO", label: "Crescimento" },
  { value: "PESSOAL", label: "Questões pessoais" },
  { value: "OUTRO", label: "Outro" },
];

export const AVALIACAO_OPCOES = [
  { value: "MUITO_BOM", label: "Muito bom" },
  { value: "BOM", label: "Bom" },
  { value: "REGULAR", label: "Regular" },
  { value: "RUIM", label: "Ruim" },
  { value: "MUITO_RUIM", label: "Muito ruim" },
];

export const FREQUENCIA_OPCOES = [
  { value: "SEMPRE", label: "Sempre" },
  { value: "MAIORIA", label: "Na maioria das vezes" },
  { value: "AS_VEZES", label: "Às vezes" },
  { value: "RARAMENTE", label: "Raramente" },
  { value: "NUNCA", label: "Nunca" },
];

export const CONDICOES_OPCOES = [
  { value: "MUITO_BOAS", label: "Muito boas" },
  { value: "BOAS", label: "Boas" },
  { value: "REGULARES", label: "Regulares" },
  { value: "RUINS", label: "Ruins" },
  { value: "MUITO_RUINS", label: "Muito ruins" },
];

export const CLAREZA_OPCOES = [
  { value: "SEMPRE", label: "Sempre" },
  { value: "FREQUENTEMENTE", label: "Frequentemente" },
  { value: "AS_VEZES", label: "Às vezes" },
  { value: "RARAMENTE", label: "Raramente" },
  { value: "NUNCA", label: "Nunca" },
];

export const CRESCIMENTO_OPCOES = [
  { value: "SIM", label: "Sim" },
  { value: "PARCIALMENTE", label: "Parcialmente" },
  { value: "NAO", label: "Não" },
];

export const TIPO_SAIDA_OPCOES = [
  { value: "PEDIDO", label: "Pedido de demissão" },
  { value: "DISPENSA", label: "Dispensa" },
  { value: "ACORDO", label: "Acordo" },
  { value: "FIM_CONTRATO", label: "Fim de contrato" },
  { value: "OUTRO", label: "Outro" },
];

export interface DesligamentoListaItem {
  id: string;
  nome: string;
  cargo: string | null;
  setor: string | null;
  tipoSaida: string;
  tipoLabel: string;
  dataDesligamento: string | null;
  prazo: string | null;
  status: string;
  statusLabel: string;
  respondidoEm: string | null;
  createdAt: string;
  link: string;
}

export interface DesligamentoRespostasView {
  motivoLabel: string;
  influencia: string;
  liderancaLabel: string;
  liderancaPorque: string | null;
  respeitoLabel: string;
  condicoesLabel: string;
  condicoesFaltava: string | null;
  clarezaLabel: string;
  crescimentoLabel: string;
  crescimentoComente: string | null;
  problemaLabel: string;
  problemaDescricao: string | null;
  permanecer: string;
  manter: string;
  melhorar: string;
  observacoes: string | null;
}

export interface DesligamentoDetalhe extends DesligamentoListaItem {
  gestorNome: string | null;
  entrevistador: string | null;
  abertoEm: string | null;
  respostas: DesligamentoRespostasView | null;
  mensagem: string;
}

export interface DesligamentoResumo {
  pendentes: number;
  respondidas: number;
  vencidas: number;
}

export interface DesligamentoPublica {
  estado: "pronta" | "respondida" | "encerrada";
  nome: string;
  cargo?: string | null;
  setor?: string | null;
  prazo?: string | null;
}

export function extractDesligamentoError(e: unknown, fallback: string): string {
  const ax = e as { response?: { data?: { error?: string } } };
  if (ax.response?.data?.error) return ax.response.data.error;
  if (e instanceof Error && e.message) return e.message;
  return fallback;
}

export async function fetchDesligamentos(): Promise<{ resumo: DesligamentoResumo; entrevistas: DesligamentoListaItem[] }> {
  const { data } = await api.get<{ success: boolean; resumo: DesligamentoResumo; entrevistas: DesligamentoListaItem[] }>(
    "/api/gente-gestao/desligamento",
  );
  return { resumo: data.resumo, entrevistas: data.entrevistas };
}

export async function fetchDesligamento(id: string): Promise<DesligamentoDetalhe> {
  const { data } = await api.get<{ success: boolean; entrevista: DesligamentoDetalhe }>(`/api/gente-gestao/desligamento/${id}`);
  return data.entrevista;
}

export async function criarDesligamento(body: {
  colaboradorId: string;
  tipoSaida: string;
  dataDesligamento: string;
  entrevistador: string;
  prazo: string;
}): Promise<DesligamentoDetalhe> {
  const { data } = await api.post<{ success: boolean; entrevista: DesligamentoDetalhe }>("/api/gente-gestao/desligamento", body);
  return data.entrevista;
}

export async function fetchDesligamentoPublico(token: string): Promise<DesligamentoPublica> {
  const { data } = await api.get<DesligamentoPublica & { success: boolean }>(
    `/api/pesquisa/desligamento/r/${encodeURIComponent(token)}`,
  );
  return data;
}

export async function enviarDesligamento(token: string, body: Record<string, string>): Promise<void> {
  await api.post(`/api/pesquisa/desligamento/r/${encodeURIComponent(token)}`, body);
}
